<template>
  <div class="flex justify-around">
    <div>
      <slot>

      </slot>
    </div>
    <div class="flex flex-col text-center">
      <div class="text-4xl"> {{valor}}</div>
      <div class="uppercase  text-xs text-gray-600"> {{legenda}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['valor', 'legenda']
}
</script>

<style>
</style>
